import { render, staticRenderFns } from "./FormaPagamentoHeader.vue?vue&type=template&id=aa0f6172"
import script from "./FormaPagamentoHeader.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports